import { DateTime } from "luxon";

/**
 * Live worked time for a triage/depollution session, in seconds.
 *
 * A session is a run of segments: each pause closes one, so elapsedSeconds carries the total of the
 * closed ones and startedOn marks the open one. Adding the two is what keeps the timer ticking
 * between renders. No open segment means the accumulated total is all there is.
 */
export const sessionElapsedSeconds = (
  session: { elapsedSeconds: number; startedOn: string | null },
  now: DateTime
): number => {
  const live = session.startedOn
    ? Math.max(
        0,
        Math.floor(now.diff(DateTime.fromISO(session.startedOn, { zone: "utc" }), "seconds").seconds)
      )
    : 0;

  return session.elapsedSeconds + live;
};

/** Formats a duration in seconds as HH:MM:SS, counting past 24 hours rather than wrapping. */
export const formatDurationHms = (seconds: number): string => {
  const safe = Math.max(0, Math.floor(seconds));
  const h = Math.floor(safe / 3600).toString().padStart(2, "0");
  const m = Math.floor((safe % 3600) / 60).toString().padStart(2, "0");
  const s = Math.floor(safe % 60).toString().padStart(2, "0");
  return `${h}:${m}:${s}`;
};
